module.exports = __webpack_public_path__ + "img/image87.e024c07.webp";